(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $73a9b14c66fa0259$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("lmekZ"), JSON.parse('["lmekZ","index.bba47c63.js","gPS1w","../ui-pack.01f87fb1.aac","6UUdd","../Dial_up_modem_noises.fcf212dc.aac","kmJwb","../Foret-fix.bf0ea3fb.aac","7CDBi","../Branches.65b0f8e3.m4a","ejLUR","../Pelle.ce95812f.m4a","g5K36","../Riviere.b3d87571.m4a","1PAUD","../Autoroute.a945b89c.m4a","7Y8yD","../Voiture_arriv.353e4d3b.m4a","aRfKO","../Radio_loin.145b3ba9.m4a","6lFkK","../Course_mort.543d9aeb.m4a","jMl5I","../Course_mort_reverse.d7569a14.m4a","1fHCG","../Attente_cig.2a7016e0.m4a","2RwxC","../Attente_vapor.59622743.m4a","cSOaR","../Voiture_entree.f030b173.m4a","gzgjn","../Pas.d3f95d51.m4a","gByL6","../Fin1_gauche_jazz.62b83880.m4a","8CNNR","../Fin2_droite_electro.9cda9c9d.m4a"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $2d353038de4934bf$exports = {};

$parcel$export($2d353038de4934bf$exports, "load", function () { return $2d353038de4934bf$export$11e63f7b0f3d9900; });
$parcel$export($2d353038de4934bf$exports, "play", function () { return $2d353038de4934bf$export$899fbdb5fa08b653; });
$parcel$export($2d353038de4934bf$exports, "audioBuffers", function () { return $2d353038de4934bf$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $2d353038de4934bf$export$c2a342ec653dfb48 = {};
function $2d353038de4934bf$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($2d353038de4934bf$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $2d353038de4934bf$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $236da9fbcdf0e712$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $2d353038de4934bf$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $2d353038de4934bf$export$899fbdb5fa08b653(name, options = {}) {
    if ($2d353038de4934bf$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $236da9fbcdf0e712$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $236da9fbcdf0e712$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $236da9fbcdf0e712$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($236da9fbcdf0e712$export$33ed28de027e9482(options.initialGain), $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $236da9fbcdf0e712$export$549ee30ac73cf40b; // custom function
    source.fade = $236da9fbcdf0e712$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $236da9fbcdf0e712$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $2d353038de4934bf$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $236da9fbcdf0e712$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $236da9fbcdf0e712$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $236da9fbcdf0e712$export$a078c61943f9dbbe;
const $236da9fbcdf0e712$export$d1d41f0cda037248 = [];
function $236da9fbcdf0e712$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $236da9fbcdf0e712$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $236da9fbcdf0e712$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $236da9fbcdf0e712$export$a078c61943f9dbbe.sampleRate);
}
function $236da9fbcdf0e712$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($236da9fbcdf0e712$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $236da9fbcdf0e712$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $236da9fbcdf0e712$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($236da9fbcdf0e712$export$33ed28de027e9482(fromLevel), $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($236da9fbcdf0e712$export$33ed28de027e9482(level), $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($236da9fbcdf0e712$export$33ed28de027e9482(level), $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $236da9fbcdf0e712$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $236da9fbcdf0e712$export$33ed28de027e9482(db), $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $236da9fbcdf0e712$export$33ed28de027e9482(db), $236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($236da9fbcdf0e712$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $236da9fbcdf0e712$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $236da9fbcdf0e712$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $236da9fbcdf0e712$export$33390c3a9a83a2f() {
    $236da9fbcdf0e712$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $236da9fbcdf0e712$export$93c25f2590a5b540(source) {
    const index = $236da9fbcdf0e712$export$d1d41f0cda037248.indexOf(source);
    $236da9fbcdf0e712$export$d1d41f0cda037248.splice(index, 1);
}
function $236da9fbcdf0e712$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $236da9fbcdf0e712$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}


// Autrona Acoustic Computer Kernel Module: Screen
// Handle all text screen drawing, save/restore, lines management, styles,
// teletype animations and sequences of this UNIX-like terminal emulation.
// Utilities
//
// Project-wide utility functions
function $d59907b8de88aa73$export$10ce5528abfb398a(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key)=>{
        if (Object.prototype.hasOwnProperty.call(source, key)) dest[key] = source[key];
    });
}
// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function $d59907b8de88aa73$export$89440da1893f4202(str, length) {
    const lines = [];
    if (str.length <= length) lines.push(str);
    else {
        let s = str;
        while(s.length > 0){
            let line;
            if (s.length > length) line = s.slice(0, s.slice(0, length).lastIndexOf(" "));
            else line = s;
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else s = "";
        }
    }
    return lines;
}
function $d59907b8de88aa73$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}
function $d59907b8de88aa73$var$constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
}
let $d59907b8de88aa73$var$newval;
function $d59907b8de88aa73$export$aee1dbae5de2db9d(n, start1, stop1, start2, stop2, withinBounds) {
    $d59907b8de88aa73$var$newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) return $d59907b8de88aa73$var$newval;
    if (start2 < stop2) return $d59907b8de88aa73$var$constrain($d59907b8de88aa73$var$newval, start2, stop2);
    return $d59907b8de88aa73$var$constrain($d59907b8de88aa73$var$newval, stop2, start2);
}



// Autrona Acoustic Computer Kernel Module: Keyboard
// Handle all key strokes, keep track of modifiers, 
// then pass the events to the currently running program,
// including main for control-sequences
// Configuration
const $183c6c0f78b3dd6d$var$modifiers = [
    "Control"
];
const $183c6c0f78b3dd6d$var$defaultPrevented = [
    " ",
    "ArrowUp",
    "ArrowDown"
];
// Variables
const $183c6c0f78b3dd6d$export$58b6cc66cb100704 = [];
// Initialize module
function $183c6c0f78b3dd6d$export$2cd8252107eb640b() {
    document.addEventListener("keydown", $183c6c0f78b3dd6d$var$handleKeyDowns);
    document.addEventListener("keyup", $183c6c0f78b3dd6d$var$handleKeyUps);
}
// General keydown event callback
function $183c6c0f78b3dd6d$var$handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    if ($183c6c0f78b3dd6d$var$modifiers.includes(e.key)) $183c6c0f78b3dd6d$var$addModifier(e.key);
    if ($183c6c0f78b3dd6d$var$defaultPrevented.includes(e.key)) e.preventDefault();
}
// keyup event callback
function $183c6c0f78b3dd6d$var$handleKeyUps(e) {
    if ($183c6c0f78b3dd6d$var$modifiers.includes(e.key)) $183c6c0f78b3dd6d$var$removeModifier(e.key);
}
// Modifier keys handling
function $183c6c0f78b3dd6d$var$addModifier(key) {
    $183c6c0f78b3dd6d$export$58b6cc66cb100704.push(key);
}
function $183c6c0f78b3dd6d$var$removeModifier(key) {
    const modifierIndex = $183c6c0f78b3dd6d$export$58b6cc66cb100704.indexOf(key);
    $183c6c0f78b3dd6d$export$58b6cc66cb100704.splice(modifierIndex, 1);
}


// Variables
let $380a3c12bb241012$var$screen;
let $380a3c12bb241012$var$container;
let $380a3c12bb241012$var$saveBuffer;
let $380a3c12bb241012$var$unveilBuffer;
let $380a3c12bb241012$var$currentLine;
let $380a3c12bb241012$var$overflow = "scroll"; // scroll or clear
let $380a3c12bb241012$var$timeout;
let $380a3c12bb241012$var$timeoutBis;
const $380a3c12bb241012$var$screenCols = 80;
const $380a3c12bb241012$var$screenLines = 42;
// Initialize module
function $380a3c12bb241012$export$2cd8252107eb640b() {
    $380a3c12bb241012$var$screen = document.querySelector(".screen");
    $380a3c12bb241012$var$container = document.querySelector(".container");
}
function $380a3c12bb241012$export$c63191ea74413a1c(mode) {
    $380a3c12bb241012$var$overflow = mode;
}
function $380a3c12bb241012$export$a1544dad697b423d() {
    $380a3c12bb241012$var$saveBuffer = $380a3c12bb241012$var$screen.innerHTML;
}
function $380a3c12bb241012$export$db239ef39aadc7fe() {
    clearTimeout($380a3c12bb241012$var$timeout);
    clearTimeout($380a3c12bb241012$var$timeoutBis);
    $380a3c12bb241012$var$screen.innerHTML = $380a3c12bb241012$var$saveBuffer;
    $380a3c12bb241012$var$currentLine = $380a3c12bb241012$var$screen.querySelector("p:last-of-type");
}
function $380a3c12bb241012$export$42ffd38884aecdac(includePinned = true) {
    if (includePinned) {
        $380a3c12bb241012$var$screen.innerHTML = "";
        $380a3c12bb241012$var$currentLine = null;
        clearTimeout($380a3c12bb241012$var$timeout);
        clearTimeout($380a3c12bb241012$var$timeoutBis);
    } else $380a3c12bb241012$var$screen.querySelectorAll("p:not(.pinned)").forEach((p)=>p.remove());
}
function $380a3c12bb241012$export$10d8903dec122b9d(content, ...style) {
    if (style.length) $380a3c12bb241012$export$3086f70939fb96fa(...style);
    $380a3c12bb241012$var$currentLine.innerText += content;
    if (DEVMODE) $380a3c12bb241012$var$checkLineLength($380a3c12bb241012$var$currentLine.innerText);
    $380a3c12bb241012$var$scroll();
}
function $380a3c12bb241012$export$57ec1e98c75cb636(content, ...style) {
    if (style.length) $380a3c12bb241012$export$3086f70939fb96fa(...style);
    $380a3c12bb241012$var$currentLine.innerHTML += content;
    if (DEVMODE) $380a3c12bb241012$var$checkLineLength($380a3c12bb241012$var$currentLine.innerText);
    $380a3c12bb241012$var$scroll();
}
function $380a3c12bb241012$var$scroll() {
    // Scroll to bottom if necessary
    if ($380a3c12bb241012$var$container.scrollTop !== $380a3c12bb241012$var$container.scrollHeight) setTimeout(()=>{
        $380a3c12bb241012$var$container.scrollTop = $380a3c12bb241012$var$container.scrollHeight;
    }, 0);
}
function $380a3c12bb241012$export$21a5ca8aa77d35ff(content, ...style) {
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$10d8903dec122b9d(content, ...style);
}
function $380a3c12bb241012$export$5a813221cd493211(content, ...style) {
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$57ec1e98c75cb636(content, ...style);
}
function $380a3c12bb241012$export$296e2d3e74e50369(content, ...style) {
    content.split("\n").forEach((c)=>$380a3c12bb241012$export$21a5ca8aa77d35ff(c, ...style));
}
function $380a3c12bb241012$export$91698095bd4ff7e0(content, ...style) {
    content.split("\n").forEach((c)=>$380a3c12bb241012$export$5a813221cd493211(c, ...style));
}
function $380a3c12bb241012$var$checkLineLength(content) {
    if (content.length > $380a3c12bb241012$var$screenCols) console.warn("Warning: Content is larger than screen columns: " + content.length, content);
}
// Delete one (or more if specified) characters from the screenBuffer
function $380a3c12bb241012$export$1ea584ca7009bcc1(n = 1) {
    $380a3c12bb241012$var$currentLine.innerText = $380a3c12bb241012$var$currentLine.innerText.slice(0, -n);
}
function $380a3c12bb241012$export$dc84f6841f96b7da() {
    // Remove blinking cursor and/or dots if active
    if ($380a3c12bb241012$var$currentLine) $380a3c12bb241012$var$currentLine.classList.remove("cursor");
    if ($380a3c12bb241012$var$currentLine) $380a3c12bb241012$var$currentLine.classList.remove("dots");
    // Limit screen rows to screenLines
    if ($380a3c12bb241012$var$screen.querySelectorAll("p").length >= $380a3c12bb241012$var$screenLines) {
        if ($380a3c12bb241012$var$overflow === "clear") $380a3c12bb241012$export$42ffd38884aecdac(false);
        else // Remove the first paragraph which is not pinned
        $380a3c12bb241012$var$screen.querySelector("p:not(.pinned)").remove();
    }
    // Create a new paragraph
    const p = document.createElement("p");
    $380a3c12bb241012$var$screen.appendChild(p);
    $380a3c12bb241012$var$currentLine = p;
}
function $380a3c12bb241012$export$b78008adb124fd21(n = 1) {
    for(let i = 0; i < n; i++){
        $380a3c12bb241012$var$currentLine.remove();
        $380a3c12bb241012$var$currentLine = $380a3c12bb241012$var$screen.querySelector("p:last-of-type");
    }
}
function $380a3c12bb241012$export$3086f70939fb96fa(...style) {
    $380a3c12bb241012$var$currentLine.classList.add(...style);
}
function $380a3c12bb241012$export$35bfa795e607ffd5() {
    $380a3c12bb241012$var$currentLine.classList.add("pinned");
}
function $380a3c12bb241012$export$58734539bbfa41a2() {
    $380a3c12bb241012$var$currentLine.classList.add("cursor");
}
function $380a3c12bb241012$export$e5383273bc7bedd() {
    // add three bouncing animated dots
    $380a3c12bb241012$var$currentLine.classList.add("dots");
}
function $380a3c12bb241012$export$6c9a7cc621cd09fe() {
    if ($380a3c12bb241012$var$currentLine) $380a3c12bb241012$var$currentLine.classList.remove("dots");
}
function $380a3c12bb241012$export$36a3a8a63357453b(content, n = null) {
    if (n == null) n = $380a3c12bb241012$var$screen.querySelectorAll("p").length;
    $380a3c12bb241012$var$screen.querySelector(`p:nth-child(${n})`).innerHTML = content;
}
function $380a3c12bb241012$export$14c7f8fd9e0dc60b() {
    const linesToFill = $380a3c12bb241012$var$screenLines - $380a3c12bb241012$var$screen.querySelectorAll("p").length;
    for(let i = 0; i < linesToFill; i++)$380a3c12bb241012$export$dc84f6841f96b7da();
}
// Automated teletype
// Will append `string` to the current line one character at a time,
// with `delay` milliseconds between each character.
function $380a3c12bb241012$export$5938cf5cddbfce5a(string, delay = 33, callback = null) {
    if (string.length > 0) {
        let charDelay = delay;
        if (delay === "00" || delay == "human") charDelay = Math.floor(Math.random() * 8) ** 2 + 50;
        // Handle inline delays
        let inlineDelayMatch = string.match(/^(§([0-9]+)).*$/);
        if (inlineDelayMatch) {
            charDelay = inlineDelayMatch[2];
            string = string.replace(inlineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $183c6c0f78b3dd6d$export$58b6cc66cb100704.includes("Control")) charDelay = 16;
        $380a3c12bb241012$var$timeout = setTimeout(()=>{
            if (string.slice(0, 1) === "\xa7") $380a3c12bb241012$export$1ea584ca7009bcc1();
            else $380a3c12bb241012$export$10d8903dec122b9d(string.slice(0, 1));
            string = string.slice(1);
            $380a3c12bb241012$export$5938cf5cddbfce5a(string, delay, callback);
        }, charDelay);
    } else if (typeof callback == "function") callback();
}
// Screen sequence
// A sequence of steps, each can be of different types
//  `Any text`         (string).     Will append the text to the current line.
//  `!n`               (new line).   Will open a new line.
//  `!c`               (clear).      Will clear the screen
//  `!s:my-class`      (CSS class).  Will add 'my-class' to the current line.
//  `!t:anytext:delay` (teletype).   Will teletype a string with given delay between each character
//  `!H:anytext      ` (HTML).       Will append the HTML to the current line.
//  `500`              (number).     Will delay further steps by X milliseconds.
function $380a3c12bb241012$export$49bb65c2ea163039(seq, callback) {
    if (seq.length > 0) {
        const step = seq[0];
        if (typeof step == "string") {
            let matchNewLine = step.match(/^!n$/);
            let matchClear = step.match(/^!c$/);
            let matchStyle = step.match(/^!s:([a-z0-9\-]+)$/);
            let matchTeletype = step.match(/^!t:(.+):([0-9]+)$/);
            let matchHTML = step.match(/^!h:(.+)$/);
            switch(true){
                case matchNewLine != null:
                    $380a3c12bb241012$export$dc84f6841f96b7da();
                    break;
                case matchClear != null:
                    $380a3c12bb241012$export$42ffd38884aecdac();
                    break;
                case matchStyle != null:
                    $380a3c12bb241012$export$3086f70939fb96fa(matchStyle[1]);
                    break;
                case matchTeletype != null:
                    $380a3c12bb241012$export$5938cf5cddbfce5a(matchTeletype[1], matchTeletype[2], ()=>{
                        // When teletype finished, recursively step ahead in sequence
                        $380a3c12bb241012$export$49bb65c2ea163039(seq.slice(1), callback);
                    });
                    break;
                case matchHTML != null:
                    $380a3c12bb241012$export$57ec1e98c75cb636(matchHTML[1]);
                    break;
                default:
                    $380a3c12bb241012$export$10d8903dec122b9d(step);
            }
            // Recursively step ahead in sequence
            if (!matchTeletype) $380a3c12bb241012$export$49bb65c2ea163039(seq.slice(1), callback);
        } else if (typeof step == "number") // Recursively step ahead in sequence with a milliseconds delay
        $380a3c12bb241012$var$timeout = setTimeout(()=>{
            $380a3c12bb241012$export$49bb65c2ea163039(seq.slice(1), callback);
        }, step);
    } else callback();
}
// New screen sequence
// A sequence of multi-line text which is to be rendered on screen
// Default mode is teletype, each caracter appended to screen one at a time
// with human-like timing.
// Handles a post-lead line delay token in the sequence: '§2000' for a 2s delay
// TODO: BBCode-like markup: (Should be implemented in teletype fonction ?)
//   - [s:col-green]...[/s] Styling with spans
function $380a3c12bb241012$export$b28a6436aebad9c0(seq, opts, callback = null) {
    const options = {
        /* Default options */ mode: "teletype",
        color: "col-orange",
        lead: "",
        lineDelay: 1000,
        dotsDelay: 2000,
        endDelay: 1000,
        newLineAtStart: true,
        newLineAtEnd: true,
        teletypeDelay: "human"
    };
    // Overwrite any default option with `opts` parameter
    $d59907b8de88aa73$export$10ce5528abfb398a(opts, options);
    if (seq.length > 0) {
        if (options.newLineAtStart) {
            $380a3c12bb241012$export$dc84f6841f96b7da();
            options.newLineAtStart = false; // To cancel new line from recursive use
        }
        // Get sequence lines as an array
        let lines = seq.split("\n");
        // Get the first line
        let line = lines[0];
        // Remove any white-space around that line (code indents mostly)
        line = line.trim();
        openLine();
        // Find optional an line delay at the string's start (`§500` for a 500ms delay)
        let lineDelay = options.lineDelay;
        let lineDelayMatch = line.match(/^(§([0-9]+)).*$/);
        if (lineDelayMatch) {
            lineDelay = lineDelayMatch[2];
            line = line.replace(lineDelayMatch[1], "").trim();
        }
        // Remove delays for development
        if (DEVMODE && $183c6c0f78b3dd6d$export$58b6cc66cb100704.includes("Control")) lineDelay = 0;
        // After the first lead occurence, remove it
        options.lead = "";
        // Prepare remaining sequence (this line excluded) for recursive use
        const remainingSeq = lines.slice(1).join("\n");
        // For teletype, display dots after 2 seconds if the line delay is longer than 2 seconds
        if (options.mode === "teletype" && lineDelay > options.dotsDelay) $380a3c12bb241012$var$timeoutBis = setTimeout($380a3c12bb241012$export$e5383273bc7bedd, options.dotsDelay);
        $380a3c12bb241012$var$timeout = setTimeout(()=>{
            // Default mode: teletype
            switch(options.mode){
                case "line":
                    $380a3c12bb241012$export$6c9a7cc621cd09fe();
                    $380a3c12bb241012$export$10d8903dec122b9d(line);
                    $380a3c12bb241012$export$b28a6436aebad9c0(remainingSeq, options, callback);
                    break;
                case "teletype":
                    $380a3c12bb241012$export$6c9a7cc621cd09fe();
                    const lines = $d59907b8de88aa73$export$89440da1893f4202(line, 80 - options.lead.length);
                    teletypeMultiline(lines.shift());
                    function teletypeMultiline(line) {
                        $380a3c12bb241012$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Handling multiline teletype
                            if (lines.length) {
                                openLine();
                                teletypeMultiline(lines.shift());
                            } else // Recursively step ahead in sequence
                            $380a3c12bb241012$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }
                    break;
                case "message":
                    const charDelay = 100; // How much time per char before printing this line
                    $380a3c12bb241012$export$e5383273bc7bedd();
                    $380a3c12bb241012$var$timeout = setTimeout(()=>{
                        $380a3c12bb241012$export$6c9a7cc621cd09fe();
                        $380a3c12bb241012$export$5938cf5cddbfce5a(line, options.teletypeDelay, ()=>{
                            // Recursively step ahead in sequence
                            $380a3c12bb241012$export$b28a6436aebad9c0(remainingSeq, options, callback);
                        });
                    }, line.length * charDelay);
                    break;
            }
        }, lineDelay);
    } else $380a3c12bb241012$var$timeout = setTimeout(()=>{
        if (options.newLineAtEnd) $380a3c12bb241012$export$dc84f6841f96b7da();
        if (callback) callback();
    }, options.endDelay);
    function openLine() {
        // Add lead
        $380a3c12bb241012$export$21a5ca8aa77d35ff(options.lead);
        // Style line
        if (typeof options.color === "string") $380a3c12bb241012$export$3086f70939fb96fa(options.color);
        else $380a3c12bb241012$export$3086f70939fb96fa(...options.color);
    }
}
function $380a3c12bb241012$export$d5cd9e826e7bdb85(callback) {
    // Analogue to save() but need its own buffer to keep save buffer intact
    $380a3c12bb241012$var$unveilBuffer = $380a3c12bb241012$var$screen.innerHTML;
    $380a3c12bb241012$export$42ffd38884aecdac();
    const paragraphs = $380a3c12bb241012$var$unveilBuffer.split("p><p");
    paragraphs.map((p, i)=>{
        if (i === 0) paragraphs[i] += "p>";
        else if (i === paragraphs.length - 1) paragraphs[i] = "<p" + paragraphs[i];
        else paragraphs[i] = "<p" + paragraphs[i] + "p>";
    });
    let i = 0;
    function step() {
        $380a3c12bb241012$var$screen.innerHTML += paragraphs[i];
        $380a3c12bb241012$var$currentLine = $380a3c12bb241012$var$screen.querySelector("p:last-of-type");
        if (i < paragraphs.length - 1) $380a3c12bb241012$var$timeout = setTimeout(step, LSI);
        else if (typeof callback === "function") callback();
        i++;
    }
    step();
}
// Display a choice list with optional title to be answered with a key press
// `answers` param is an object: { keyName: [answerText, callback]}
// Example:
//  screen.choice('Votre réponse:', {
//      '1': ['Ben.. Je sais pas trop...', passageB],
//      '2': ['Heu... Je vois rien...', passageC],
//  });
// Would yield:
//  Votre réponse:
//    [1] Ben.. Je sais pas trop...
//    [2] Heu... Je vois rien...
//  > 
function $380a3c12bb241012$export$7a5825874deea16a(title, answers) {
    // Display optional title
    if (title) $380a3c12bb241012$export$21a5ca8aa77d35ff(title);
    let seq = "";
    // Display one choice per line
    for (const [key, answer] of Object.entries(answers)){
        const indent = 5 + key.length;
        const maxLength = 80 - indent;
        const lines = $d59907b8de88aa73$export$89440da1893f4202(answer[0], maxLength);
        lines.forEach((line, index)=>{
            if (index === 0) seq += `[${key}] ${line}\n`;
            else seq += "".padStart(indent) + line + "\n";
        });
    }
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        color: "col-dark-cyan",
        lead: "",
        lineDelay: 100,
        endDelay: 100,
        mode: "line",
        newLineAtStart: false,
        newLineAtEnd: false
    }, ()=>{
        // Display prompt
        $380a3c12bb241012$export$21a5ca8aa77d35ff("> ", "col-cyan");
        $380a3c12bb241012$export$58734539bbfa41a2();
        $e891fed206f251fc$export$a23ad60f6022999e("question");
    });
    registerKeyDownEvent();
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            const answer = Object.entries(answers).find((answer)=>answer[0] === e.key);
            if (answer) {
                $380a3c12bb241012$export$10d8903dec122b9d(answer[1][0]);
                $e891fed206f251fc$export$a23ad60f6022999e("validate");
                answer[1][1]();
            } else {
                console.log("Invalid answer given:", e.key);
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}
function $380a3c12bb241012$export$34c871b8a7d7e324(title, callback) {
    // Display optional title
    if (title) $380a3c12bb241012$export$21a5ca8aa77d35ff(title);
    // Display prompt
    $380a3c12bb241012$export$21a5ca8aa77d35ff("> ", "col-cyan");
    $380a3c12bb241012$export$58734539bbfa41a2();
    $e891fed206f251fc$export$a23ad60f6022999e("question");
    registerKeyDownEvent();
    let answer = "";
    // Local one-time event listener
    function registerKeyDownEvent() {
        document.addEventListener("keydown", (e)=>{
            if (e.key == "Enter") {
                $e891fed206f251fc$export$a23ad60f6022999e("validate");
                callback(answer);
            } else if (e.key == "Backspace") {
                if (answer.length) {
                    // Remove last keystroke from command line on screen
                    $380a3c12bb241012$export$1ea584ca7009bcc1();
                    // Remove last keystroke from command line
                    answer = answer.slice(0, -1);
                }
                registerKeyDownEvent();
            } else {
                if (e.key.length == 1) {
                    // Add keystroke to answer and screen buffer
                    answer += e.key;
                    $380a3c12bb241012$export$10d8903dec122b9d(e.key);
                }
                // Enable next keystroke
                registerKeyDownEvent();
            }
        }, {
            once: true
        });
    }
}


// Autrona Acoustic Computer Program: Remote
// Connect to a remote terminal



var $8ae1175b6f82b9d4$exports = {};

$parcel$export($8ae1175b6f82b9d4$exports, "init", function () { return $8ae1175b6f82b9d4$export$2cd8252107eb640b; });
$parcel$export($8ae1175b6f82b9d4$exports, "run", function () { return $8ae1175b6f82b9d4$export$889ea624f2cb2c57; });
$parcel$export($8ae1175b6f82b9d4$exports, "exit", function () { return $8ae1175b6f82b9d4$export$5c525e238923a57d; });
// Autrona Acoustic Computer Program: Pluie
// Une première expérience



// Variables
let $8ae1175b6f82b9d4$var$userName;
// Références à loops audio
const $8ae1175b6f82b9d4$var$oneShots = [];
const $8ae1175b6f82b9d4$var$loops = {};
let $8ae1175b6f82b9d4$var$timeout;
let $8ae1175b6f82b9d4$var$exitCallback;
// Niveaux Audio en décibels
//   0 db = unité = volume maximal
//   -90 db = volume à ~zéro
const $8ae1175b6f82b9d4$var$audioLevels = {
    // Niveaux absolus initiaux ou post fade-in
    "background": -3,
    "foret": 0,
    "branches": 0,
    "pelle": -12,
    "riviere": 0,
    "autoroute": -2,
    "voiture-arrive": 0,
    "radio-loin": -5,
    "course-mort": 0,
    "course-mort-rev": -6,
    "attente-cigarette": -6,
    "attente-vaporette": -6,
    "voiture-entree": 0,
    "pas": -8,
    "fin-jazz": 0,
    "fin-electro": 0,
    // Attenuations
    "attenuation-attente": -12,
    "attenuation-voiture": -90
};
// Initialize module
function $8ae1175b6f82b9d4$export$2cd8252107eb640b() {}
function $8ae1175b6f82b9d4$export$889ea624f2cb2c57(exitCb) {
    $8ae1175b6f82b9d4$var$exitCallback = exitCb;
    prompt = ""; // Reset
    $8ae1175b6f82b9d4$var$resetScreen();
    $e891fed206f251fc$export$a23ad60f6022999e("validate");
    $8ae1175b6f82b9d4$var$timeout = setTimeout(()=>{
        // Screen sequence. See screen.js comments for documentation
        const seq = `
            \xa73000 Votre num \xa7\xa7\xa7om ?
            `;
        $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
            /* Sequence options */ color: "col-green",
            lead: "Nar-6> ",
            teletypeDelay: "human"
        }, ()=>{
            $380a3c12bb241012$export$34c871b8a7d7e324(null, $8ae1175b6f82b9d4$var$passageA);
        });
    }, 2000);
}
function $8ae1175b6f82b9d4$var$resetScreen() {
    $380a3c12bb241012$export$42ffd38884aecdac();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("AutronaTerm v2.5 - 802.11", "col-red", "col-bg-red");
    $380a3c12bb241012$export$35bfa795e607ffd5();
}
function $8ae1175b6f82b9d4$var$passageA(answer) {
    $8ae1175b6f82b9d4$var$userName = answer;
    const seq = `
        \xa72000 Souvenez-vous...
        \xa75000 Souvenez-vous.
        
        \xa75000 Je sais que vous avez d\xe9j\xe0 v\xe9cu \xe7a.
        \xa75000 Comment les \xe9v\xe9nements s\u{2019}\xe9taient-ils encha\xeen\xe9s ?
        
        \xa77000 Vous \xe9tiez en for\xeat.
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, $8ae1175b6f82b9d4$var$passageA1);
}
function $8ae1175b6f82b9d4$var$passageA1() {
    $8ae1175b6f82b9d4$var$loops.foret = $2d353038de4934bf$exports.play("foret", {
        loop: true,
        loopStart: 1.0,
        loopEnd: 50.116
    }).fadeTo(10, $8ae1175b6f82b9d4$var$audioLevels["foret"]);
    const seq = `
        \xa724000 Vous marchiez.
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, $8ae1175b6f82b9d4$var$passageA2);
}
function $8ae1175b6f82b9d4$var$passageA2() {
    $8ae1175b6f82b9d4$var$loops.branches = $2d353038de4934bf$exports.play("branches", {
        loop: true
    }).fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["branches"]);
    $8ae1175b6f82b9d4$var$timeout = setTimeout(()=>{
        $8ae1175b6f82b9d4$var$loops.pelle = $2d353038de4934bf$exports.play("pelle", {
            loop: true
        }).fadeTo(15, $8ae1175b6f82b9d4$var$audioLevels["pelle"]);
    }, 20000);
    const seq = `
        \xa731000 Stop. Vous entendez ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, $8ae1175b6f82b9d4$var$passageA3);
}
function $8ae1175b6f82b9d4$var$passageA3() {
    $8ae1175b6f82b9d4$var$loops.branches.fade(1, -90, true);
    const seq = `
        \xa710000 Ecoutez bien.
        \xa72000 Que fabrique-t-il ?
        
        \xa715000 Je suis s\xfbr que vous vous en souvenez.
        \xa74000 C\u{2019}est l\xe0 que tout a commenc\xe9 !
        
        \xa72000 Souvenez-vous...
        \xa75000 Que fabrique-t-il ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Ben... Je sais pas trop.",
                $8ae1175b6f82b9d4$var$passageB
            ],
            "2": [
                "Heu... Je vois rien.",
                $8ae1175b6f82b9d4$var$passageC
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageB() {
    const seq = `
        \xa73000 On m\u{2019}a dit que vous aviez l\u{2019}oreille fine...
        Est-ce une s\xe9v\xe8re perte de m\xe9moire ou un simple oubli ?
        
        \xa710000 Allez. dites-moi...
        
        \xa75000 O\xf9 se trouve-t-il ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        endDelay: 3000
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Au bord d\u2019une rivi\xe8re ?",
                $8ae1175b6f82b9d4$var$passageD
            ],
            "2": [
                "A moins que ce soit pr\xe8s de l\u2019autoroute...",
                $8ae1175b6f82b9d4$var$passageE
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageC() {
    const seq = `
        \xa72000 Et moi ?
        Vous croyez que je vois quelque chose ?
        Vous \xeates mes oreilles !
        
        \xa73000 Et ce sont vos souvenirs !

        \xa73000 Allez. dites-moi...
        
        \xa75000 O\xf9 se trouve-t-il ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        endDelay: 3000
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Heu... disons pr\xe8s d\u2019une autoroute. ",
                $8ae1175b6f82b9d4$var$passageE
            ],
            "2": [
                "Ou peut-\xeatre \xe0 c\xf4t\xe9 de la rivi\xe8re ?",
                $8ae1175b6f82b9d4$var$passageD
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageD() {
    $8ae1175b6f82b9d4$var$loops.riviere = $2d353038de4934bf$exports.play("riviere", {
        loop: true
    }).fadeTo(1.0, $8ae1175b6f82b9d4$var$audioLevels["riviere"]);
    const seq = `
        \xa72000 Bravo !
        
        Alors vous voyez... \xa71000 vous \xeates comme un d\xe9miurge !
        Les sons sont votre sp\xe9cialit\xe9... \xa71000 la musique... \xa71000 l\u{2019}encha\xeenement des bruits... \xa71000 une symphonie qui court sur la rivi\xe8re...
        
        \xa710000 Ne me dites pas que vous avez une m\xe9moire visuelle !
        On risque de mal s\u{2019}entendre.
        
        \xa75000 Bon, alors.
        \xa72000 Que fabrique-t-il ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Je crois qu\u2019il faisait juste des exercices physiques.",
                $8ae1175b6f82b9d4$var$passageF
            ],
            "2": [
                "Peut-\xeatre qu\u2019il creuse ?",
                $8ae1175b6f82b9d4$var$passageG
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageE() {
    $8ae1175b6f82b9d4$var$loops.autoroute = $2d353038de4934bf$exports.play("autoroute", {
        loop: true
    }).fadeTo(1.0, $8ae1175b6f82b9d4$var$audioLevels["autoroute"]);
    const seq = `
        \xa72000 Bravo !
        
        \xa74000 Alors vous voyez... vous \xeates comme un dieu cr\xe9ateur !

        Les sons sont votre sp\xe9cialit\xe9... la musique... l\u{2019}encha\xeenement des bruits...
        Une symphonie qui roule comme des voitures sur une autoroute...
        
        \xa710000 Ne me dites pas que vous avez une m\xe9moire visuelle !
        On risque de mal s\u{2019}entendre.
        
        \xa75000 Bon, alors.
        \xa72000 Que fabrique-t-il ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Je crois qu\u2019il faisait juste des exercices physiques.",
                $8ae1175b6f82b9d4$var$passageF
            ],
            "2": [
                "Peut-\xeatre qu\u2019il creuse ?",
                $8ae1175b6f82b9d4$var$passageG
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageF() {
    const seq = `
        \xa72000 Wha\xa71000\xa7\xa7\xa7Non ${$8ae1175b6f82b9d4$var$userName} !
        Il ne faisait pas juste des exercices physiques...
        
        \xa78000 Vous croyez que tout \xe7a n\u{2019}est qu\u{2019}un jeu ?
        \xa73000 Que vous pouvez choisir comme bon vous semble ?
        
        \xa75000 Concentrez-vous un peu !
        Alors ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Alors... il creuse ! ",
                $8ae1175b6f82b9d4$var$passageG
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageG() {
    const seq = `
        \xa73000 Tr\xe8s juste... \xa72000 en effet.
        Il creuse.
        
        \xa75000 Il creuse pour enterrer... \xa72000 quelque chose.
        
        \xa78000 Et je crois que \xe7a vous effraie.
        Avait-il une arme ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Il me semble que oui.",
                $8ae1175b6f82b9d4$var$passageH
            ],
            "2": [
                "Ca fait tr\xe8s s\xe9rie B !",
                $8ae1175b6f82b9d4$var$passageH2
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageH() {
    const seq = `
        \xa72000 Vous n'\xeates pas s\xfbr ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
        /* Sequence callback */ $8ae1175b6f82b9d4$var$passageHI();
    });
}
function $8ae1175b6f82b9d4$var$passageH2() {
    const seq = `
        \xa72000 Tr\xeave de plaisanterie ${$8ae1175b6f82b9d4$var$userName} !
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
        /* Sequence callback */ $8ae1175b6f82b9d4$var$passageHI();
    });
}
function $8ae1175b6f82b9d4$var$passageHI() {
    const seq = `
        \xa73000 Vous avez au moins le souvenir d\u{2019}avoir trouv\xe9 cet individu tr\xe8s dangereux...
        Il vous faudra fuir \xe0 la moindre occasion !
        
        \xa74000 Attendez ! Chut ! Taisez-vous !
        Une voiture arrive...
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$21a5ca8aa77d35ff("", "col-green");
        $380a3c12bb241012$export$e5383273bc7bedd();
        $8ae1175b6f82b9d4$var$oneShots.push($2d353038de4934bf$exports.play("voiture-arrive", {
            onended: $8ae1175b6f82b9d4$var$passageHI2
        }).fadeTo(4.0, $8ae1175b6f82b9d4$var$audioLevels["voiture-arrive"]));
    });
}
function $8ae1175b6f82b9d4$var$passageHI2() {
    $8ae1175b6f82b9d4$var$loops.radioLoin = $2d353038de4934bf$exports.play("radio-loin", {
        loop: true
    }).fadeTo(1.0, $8ae1175b6f82b9d4$var$audioLevels["radio-loin"]);
    const seq = `
        \xa72000 Etrange.
        La porti\xe8re est rest\xe9e ouverte.
        On entend d\u{2019}ici l\u{2019}autoradio.

        Vous \xeates \xe0 quelques m\xe8tres de la voiture mais...
        \xa73000 Y avait-il vraiment quelqu'un au volant ?
        
        \xa75000 Et pourquoi l\u{2019}autre continue de creuser ?
        Votre m\xe9moire est floue ${$8ae1175b6f82b9d4$var$userName}.
        
        \xa75000 Cette voiture vous attire. Que faites-vous ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "",
        teletypeDelay: "human",
        newLineAtStart: false
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Je cours vers la voiture pour la voler et m\u2019enfuir !",
                $8ae1175b6f82b9d4$var$passageK
            ],
            "2": [
                "J\u2019attends un moment plus propice.  ",
                $8ae1175b6f82b9d4$var$passageJ
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageJ() {
    const seq = `
        \xa73000 La prudence \xe9tait votre boussole... \xa71000 c\u{2019}est bien.
        
        \xa73000 Vous \xeates sage... \xa71000 raisonnable.
        Vous attendez donc.
        
        \xa74000 \xc7a risque de durer quelques minutes...
        
        \xa74000 Une cigarette ?
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Oui, une clope, avec plaisir !",
                $8ae1175b6f82b9d4$var$passageL2
            ],
            "2": [
                "Pourquoi pas. Mais seulement une e-cigarette.",
                $8ae1175b6f82b9d4$var$passageL1
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageK() {
    $8ae1175b6f82b9d4$var$loops.courseMort = $2d353038de4934bf$exports.play("course-mort", {
        loop: true,
        loopStart: 20.0,
        loopEnd: 24.105
    }).fadeTo(2, $8ae1175b6f82b9d4$var$audioLevels["course-mort"]);
    setTimeout(()=>{
        $8ae1175b6f82b9d4$var$loops.pelle.fade(1);
        $8ae1175b6f82b9d4$var$loops.foret.fade(1);
        if ($8ae1175b6f82b9d4$var$loops.riviere) $8ae1175b6f82b9d4$var$loops.riviere.fade(1);
        if ($8ae1175b6f82b9d4$var$loops.autoroute) $8ae1175b6f82b9d4$var$loops.autoroute.fade(1);
        $8ae1175b6f82b9d4$var$loops.radioLoin.fade(1);
    }, 7000); // Coup de feu à 7 secondes
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("Vous courez vers la voiture", "col-light-gray", "italic");
    $380a3c12bb241012$export$e5383273bc7bedd();
    $8ae1175b6f82b9d4$var$timeout = setTimeout(()=>{
        const seq = `
            \xa71000 La mort ?
            
            \xa73000 D\xe9j\xe0 ? \xa74000 Vous \xeates s\xfbr ?
            
            \xa73000 Non \xe7a ne doit pas \xeatre \xe7a...
            `;
        $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
            /* Sequence options */ color: "col-green",
            lead: "Nar-6> ",
            teletypeDelay: "human"
        }, ()=>{
            /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
                "1": [
                    "Revenir en arri\xe8re",
                    $8ae1175b6f82b9d4$var$passageK2
                ]
            });
        });
    }, 18000);
}
function $8ae1175b6f82b9d4$var$passageK2() {
    $8ae1175b6f82b9d4$var$loops.courseMort.fade(1, -90, true);
    $8ae1175b6f82b9d4$var$oneShots.push($2d353038de4934bf$exports.play("course-mort-rev", {
        onended: $8ae1175b6f82b9d4$var$passageK3
    }).fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["course-mort-rev"]));
}
function $8ae1175b6f82b9d4$var$passageK3() {
    $8ae1175b6f82b9d4$var$loops.pelle.fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["pelle"]);
    $8ae1175b6f82b9d4$var$loops.foret.fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["foret"]);
    if ($8ae1175b6f82b9d4$var$loops.riviere) $8ae1175b6f82b9d4$var$loops.riviere.fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["riviere"]);
    if ($8ae1175b6f82b9d4$var$loops.autoroute) $8ae1175b6f82b9d4$var$loops.autoroute.fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["autoroute"]);
    $8ae1175b6f82b9d4$var$loops.radioLoin.fadeTo(1, $8ae1175b6f82b9d4$var$audioLevels["radio-loin"]);
    const seq = `
        \xa72000 Vous \xeatiez \xe0 quelques m\xe8tres de la voiture.
        Elle semble \xeatre venue pour vous, mais...
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "J\u2019attends un moment plus propice.",
                $8ae1175b6f82b9d4$var$passageJ
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageL1() {
    // Fade out to pause
    $8ae1175b6f82b9d4$var$loops.pelle.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    $8ae1175b6f82b9d4$var$loops.foret.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    if ($8ae1175b6f82b9d4$var$loops.riviere) $8ae1175b6f82b9d4$var$loops.riviere.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    if ($8ae1175b6f82b9d4$var$loops.autoroute) $8ae1175b6f82b9d4$var$loops.autoroute.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    $8ae1175b6f82b9d4$var$loops.radioLoin.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    $8ae1175b6f82b9d4$var$loops.attenteVaporette = $2d353038de4934bf$exports.play("attente-vaporette", {
        initialGain: $8ae1175b6f82b9d4$var$audioLevels["attente-vaporette"],
        when: 2,
        loop: true,
        loopStart: 5.0,
        loopEnd: 28.0,
        onended: $8ae1175b6f82b9d4$var$passageL
    });
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("Vous utilisez une e-cigarette", "col-light-gray", "italic");
    $380a3c12bb241012$export$e5383273bc7bedd();
    $8ae1175b6f82b9d4$var$timeout = setTimeout(()=>{
        $380a3c12bb241012$export$dc84f6841f96b7da();
        $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Arreter de vapoter",
                ()=>{
                    $8ae1175b6f82b9d4$var$loops.attenteVaporette.fade(2, -90, true);
                }
            ]
        });
    }, 3000);
}
function $8ae1175b6f82b9d4$var$passageL2() {
    // Fade out to pause
    $8ae1175b6f82b9d4$var$loops.pelle.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    $8ae1175b6f82b9d4$var$loops.foret.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    if ($8ae1175b6f82b9d4$var$loops.riviere) $8ae1175b6f82b9d4$var$loops.riviere.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    if ($8ae1175b6f82b9d4$var$loops.autoroute) $8ae1175b6f82b9d4$var$loops.autoroute.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    $8ae1175b6f82b9d4$var$loops.radioLoin.fade(2, $8ae1175b6f82b9d4$var$audioLevels["attenuation-attente"]);
    $8ae1175b6f82b9d4$var$loops.attenteCigarette = $2d353038de4934bf$exports.play("attente-cigarette", {
        initialGain: $8ae1175b6f82b9d4$var$audioLevels["attente-cigarette"],
        when: 2,
        loop: true,
        loopStart: 1.0,
        loopEnd: 11.5,
        onended: $8ae1175b6f82b9d4$var$passageL
    });
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("Vous fumez une cigarette", "col-light-gray", "italic");
    $380a3c12bb241012$export$e5383273bc7bedd();
    $8ae1175b6f82b9d4$var$timeout = setTimeout(()=>{
        $380a3c12bb241012$export$dc84f6841f96b7da();
        $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Eteindre la cigarette",
                ()=>{
                    $8ae1175b6f82b9d4$var$loops.attenteCigarette.loop = false;
                }
            ]
        });
    }, 3000);
}
function $8ae1175b6f82b9d4$var$passageL() {
    // Fade back in from pause
    $8ae1175b6f82b9d4$var$loops.foret.fadeTo(2, $8ae1175b6f82b9d4$var$audioLevels["foret"]);
    if ($8ae1175b6f82b9d4$var$loops.riviere) $8ae1175b6f82b9d4$var$loops.riviere.fadeTo(2, $8ae1175b6f82b9d4$var$audioLevels["riviere"]);
    if ($8ae1175b6f82b9d4$var$loops.autoroute) $8ae1175b6f82b9d4$var$loops.autoroute.fadeTo(2, $8ae1175b6f82b9d4$var$audioLevels["autoroute"]);
    $8ae1175b6f82b9d4$var$loops.radioLoin.fadeTo(2, $8ae1175b6f82b9d4$var$audioLevels["radio-loin"]);
    $8ae1175b6f82b9d4$var$loops.pelle.fade(1, -90, true);
    const seq = `
        \xa72000 Vous \xeates toujours l\xe0 ?
        
        \xa73000 Ecoutez !
        \xa74000 Il n\u{2019}y a plus personne ?
        
        \xa78000 Le type qui creuse est parti...
        
        \xa74000 La voiture est toujours l\xe0... \xa71000 pr\xeate \xe0 l\u{2019}emploi.
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Quand faut y aller, faut y aller !",
                $8ae1175b6f82b9d4$var$passageM
            ],
            "2": [
                "Partir \xe0 la recherche du type qui creusait ?",
                $8ae1175b6f82b9d4$var$passageM2
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageM() {
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("Vous marchez vers la voiture", "col-light-gray", "italic");
    $380a3c12bb241012$export$e5383273bc7bedd();
    $8ae1175b6f82b9d4$var$loops.radioLoin.fade(12, 6);
    $8ae1175b6f82b9d4$var$oneShots.push($2d353038de4934bf$exports.play("pas", {
        initialGain: $8ae1175b6f82b9d4$var$audioLevels["pas"],
        onended: ()=>{
            $8ae1175b6f82b9d4$var$loops.voitureRadio = $2d353038de4934bf$exports.play("voiture-entree", {
                initialGain: $8ae1175b6f82b9d4$var$audioLevels["voiture-entree"],
                loop: true,
                loopStart: 3.591,
                loopEnd: 16.5
            });
            // Diminuer ou arrêter les sons
            $8ae1175b6f82b9d4$var$loops.foret.fade(1, $8ae1175b6f82b9d4$var$audioLevels["attenuation-voiture"], true);
            if ($8ae1175b6f82b9d4$var$loops.riviere) $8ae1175b6f82b9d4$var$loops.riviere.fade(1, $8ae1175b6f82b9d4$var$audioLevels["attenuation-voiture"], true);
            if ($8ae1175b6f82b9d4$var$loops.autoroute) $8ae1175b6f82b9d4$var$loops.autoroute.fade(1, $8ae1175b6f82b9d4$var$audioLevels["attenuation-voiture"], true);
            $8ae1175b6f82b9d4$var$loops.radioLoin.fade(1, $8ae1175b6f82b9d4$var$audioLevels["attenuation-voiture"], true);
            const seq = `
                \xa72000 Vous voil\xe0 dans la voiture.
                Vous vous en souvenez ?

                \xa72000 La radio baragouinait des inepties contemporaines...
                Y avait comme un bug.
                
                \xa72000 Vous vous en souvenez ?
            `;
            $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
                /* Sequence options */ color: "col-green",
                lead: "Nar-6> ",
                teletypeDelay: "human"
            }, ()=>{
                /* Sequence callback */ $380a3c12bb241012$export$7a5825874deea16a("", {
                    "1": [
                        "Taper sur la gauche de la radio",
                        $8ae1175b6f82b9d4$var$passageN1
                    ],
                    "2": [
                        "Taper sur la droite de la radio",
                        $8ae1175b6f82b9d4$var$passageN2
                    ]
                });
            });
        }
    }));
}
function $8ae1175b6f82b9d4$var$passageM2() {
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("<Error: Memory address out of range>", "col-dark-red", "italic");
    $e891fed206f251fc$export$a23ad60f6022999e("error");
    $8ae1175b6f82b9d4$var$timeout = setTimeout(()=>{
        const seq = `
            \xa75000 Oups d\xe9sol\xe9, je crois qu'il y a une erreur
            Ces souvenirs ne sont pas accessibles...
            
            \xa73000 Peut-\xeatre faut-il attendre une mise \xe0 jour ?
            `;
        $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
            /* Sequence options */ color: "col-green",
            lead: "Nar-6> ",
            teletypeDelay: "human"
        }, ()=>{
            $380a3c12bb241012$export$7a5825874deea16a("", {
                "1": [
                    "Revenir au choix pr\xe9c\xe9dent",
                    $8ae1175b6f82b9d4$var$passageM3
                ]
            });
        });
    }, 2000);
}
function $8ae1175b6f82b9d4$var$passageM3() {
    const seq = `
        \xa72000 Donc le type qui creuse est parti.

        \xa72000 La voiture est toujours l\xe0... pr\xeate \xe0 l\u{2019}emploi.
        `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human"
    }, ()=>{
        $380a3c12bb241012$export$7a5825874deea16a("", {
            "1": [
                "Quand faut y aller, faut y aller !",
                $8ae1175b6f82b9d4$var$passageM
            ]
        });
    });
}
function $8ae1175b6f82b9d4$var$passageN1() {
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("La radio diffuse de la musique", "col-light-gray", "italic");
    $380a3c12bb241012$export$e5383273bc7bedd();
    $8ae1175b6f82b9d4$var$loops.voitureRadio.fade(1, -90, true);
    $8ae1175b6f82b9d4$var$oneShots.push($2d353038de4934bf$exports.play("fin-jazz", {
        initialGain: $8ae1175b6f82b9d4$var$audioLevels["fin-jazz"],
        onended: ()=>{
            $8ae1175b6f82b9d4$export$5c525e238923a57d();
        }
    }));
    $8ae1175b6f82b9d4$var$timeout = setTimeout($8ae1175b6f82b9d4$var$passageO, 20000);
}
function $8ae1175b6f82b9d4$var$passageN2() {
    $380a3c12bb241012$export$dc84f6841f96b7da();
    $380a3c12bb241012$export$21a5ca8aa77d35ff("La radio diffuse de la musique", "col-light-gray", "italic");
    $380a3c12bb241012$export$e5383273bc7bedd();
    $8ae1175b6f82b9d4$var$loops.voitureRadio.fade(1, -90, true);
    $8ae1175b6f82b9d4$var$oneShots.push($2d353038de4934bf$exports.play("fin-electro", {
        initialGain: $8ae1175b6f82b9d4$var$audioLevels["fin-electro"],
        onended: ()=>{
            $8ae1175b6f82b9d4$export$5c525e238923a57d();
        }
    }));
    $8ae1175b6f82b9d4$var$timeout = setTimeout($8ae1175b6f82b9d4$var$passageO, 20000);
}
function $8ae1175b6f82b9d4$var$passageO() {
    const seq = `
        \xa72000 Vous avez fui !
        
        \xa78000 Vous \xeates en s\xe9curit\xe9. 
        
        \xa78000 Au moins pour un moment...
        
        \xa78000 Vous \xeates en route pour d\u{2019}autres aventures,
        
        \xa78000 d\u{2019}autres embranchements.

        \xa78000 Bient\xf4t...
    `;
    $380a3c12bb241012$export$b28a6436aebad9c0(seq.trim(), {
        /* Sequence options */ color: "col-green",
        lead: "Nar-6> ",
        teletypeDelay: "human",
        newLineAtEnd: false
    }, ()=>{
    // timeout = setTimeout(() => {
    //     exit();
    // }, 8000);
    });
}
function $8ae1175b6f82b9d4$var$stopAllSounds() {
    $8ae1175b6f82b9d4$var$oneShots.forEach((source)=>source.stop());
    Object.values($8ae1175b6f82b9d4$var$loops).forEach((source)=>source.stop());
}
function $8ae1175b6f82b9d4$export$5c525e238923a57d() {
    $8ae1175b6f82b9d4$var$stopAllSounds();
    $380a3c12bb241012$export$42ffd38884aecdac();
    $8ae1175b6f82b9d4$var$exitCallback();
}


// Variables
let $346325bb3c7976af$var$keyBoardResponsive = true;
let $346325bb3c7976af$var$address;
let $346325bb3c7976af$var$audioSource;
// Configuration
const $346325bb3c7976af$var$dialUp = true;
// Game data
const $346325bb3c7976af$var$addresses = {
    "10.1.2.3": $8ae1175b6f82b9d4$exports
};
function $346325bb3c7976af$export$889ea624f2cb2c57(...args) {
    $346325bb3c7976af$var$keyBoardResponsive = true;
    $346325bb3c7976af$var$address = args[0] || "";
    $380a3c12bb241012$export$a1544dad697b423d();
    $380a3c12bb241012$export$42ffd38884aecdac();
    // Header
    $380a3c12bb241012$export$dc84f6841f96b7da();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        100,
        "AutronaTerm v2.5 - 802.11",
        "!s:col-red",
        "!s:col-bg-red",
        100,
        "!n",
        100,
        "!n"
    ];
    $380a3c12bb241012$export$49bb65c2ea163039(seq, ()=>{
        if ($346325bb3c7976af$var$address) {
            $380a3c12bb241012$export$10d8903dec122b9d("Connecting to " + $346325bb3c7976af$var$address);
            $346325bb3c7976af$var$openConnection();
        } else {
            $380a3c12bb241012$export$10d8903dec122b9d("Enter remote terminal address > ");
            $380a3c12bb241012$export$58734539bbfa41a2();
        }
    });
}
function $346325bb3c7976af$var$openConnection() {
    $346325bb3c7976af$var$keyBoardResponsive = false;
    if ($346325bb3c7976af$var$address in $346325bb3c7976af$var$addresses) {
        if ($346325bb3c7976af$var$dialUp) {
            // Play modem dial up sound
            $346325bb3c7976af$var$audioSource = $2d353038de4934bf$exports.play("dial-up-modem", {
                initialGain: -20
            });
            // Screen sequence. See screen.js comments for documentation
            const seq = `
                \xa71000<opening line>
                \xa7800<dialing ISP...>
                \xa74300<initiating connection...>
                \xa73900<negotiating modulation mode...>
                \xa73200<probing line...>
                \xa71400<adjusting equalizers...>

                \xa79200<connection established>

                \xa72200<muting modem>

                \xa7500<remote tty override from ${$346325bb3c7976af$var$address}>
            `.trim();
            $380a3c12bb241012$export$b28a6436aebad9c0(seq, {
                color: [
                    "col-dark-green",
                    "italic"
                ],
                mode: "line",
                lineDelay: 0,
                endDelay: 0
            }, ()=>{
                setTimeout(()=>{
                    $346325bb3c7976af$var$stopSounds();
                    $346325bb3c7976af$var$addresses[$346325bb3c7976af$var$address].run($346325bb3c7976af$var$exit);
                }, 2000);
            });
        } else {
            $380a3c12bb241012$export$dc84f6841f96b7da();
            // Screen sequence. See screen.js comments for documentation
            const seq = [
                100,
                "!s:col-dark-green",
                "<initiating connection...>",
                "!n",
                5160,
                "!s:col-green",
                "<connection established>",
                "!n"
            ];
            $380a3c12bb241012$export$49bb65c2ea163039(seq, ()=>{
                $e891fed206f251fc$export$a23ad60f6022999e("connected");
                setTimeout(()=>{
                    $346325bb3c7976af$var$stopSounds();
                    $346325bb3c7976af$var$addresses[$346325bb3c7976af$var$address].run($346325bb3c7976af$var$exit);
                }, 1000);
            });
        }
    } else {
        console.log("Bad address: " + $346325bb3c7976af$var$address);
        $346325bb3c7976af$var$address = "";
        $380a3c12bb241012$export$dc84f6841f96b7da();
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            100,
            "!s:col-dark-green",
            "<initiating connection...>",
            "!n",
            5160,
            "!s:col-dark-red",
            "<unable to reach host>",
            "!n",
            100,
            "Enter remote terminal address > "
        ];
        $380a3c12bb241012$export$49bb65c2ea163039(seq, ()=>{
            $e891fed206f251fc$export$a23ad60f6022999e("error");
            $380a3c12bb241012$export$58734539bbfa41a2();
            $346325bb3c7976af$var$keyBoardResponsive = true;
        });
    }
}
function $346325bb3c7976af$var$stopSounds() {
    if ($346325bb3c7976af$var$audioSource) $346325bb3c7976af$var$audioSource.stop();
}
function $346325bb3c7976af$var$exit() {
    console.log("Remote program exit");
}




function $f47c83d30a62c4c8$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $236da9fbcdf0e712$export$fbb4d68fe60c1629().then(()=>{
            $e891fed206f251fc$export$b3571188c770cc5a();
        });
    });
}
function $f47c83d30a62c4c8$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $f47c83d30a62c4c8$export$4bb981a91e4f02eb() {
    document.querySelector(".js-start").classList.remove("hidden");
    $f47c83d30a62c4c8$export$471f7ae5c4103ae1(null);
}



var $63cdaed10fce03c5$exports = {};

$63cdaed10fce03c5$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../ui-pack.01f87fb1.aac";


var $d78264450f2ab72a$exports = {};

$d78264450f2ab72a$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Dial_up_modem_noises.fcf212dc.aac";


var $f9218e9b181772c3$exports = {};

$f9218e9b181772c3$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Foret-fix.bf0ea3fb.aac";


var $370d5344dddfcb5d$exports = {};

$370d5344dddfcb5d$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Branches.65b0f8e3.m4a";


var $45fc23955f1cdb60$exports = {};

$45fc23955f1cdb60$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Pelle.ce95812f.m4a";


var $7b7df9faf4c17568$exports = {};

$7b7df9faf4c17568$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Riviere.b3d87571.m4a";


var $2f1d8486ece2ef67$exports = {};

$2f1d8486ece2ef67$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Autoroute.a945b89c.m4a";


var $2bf7632f8595d927$exports = {};

$2bf7632f8595d927$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Voiture_arriv.353e4d3b.m4a";


var $f483ee1086f5baf7$exports = {};

$f483ee1086f5baf7$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Radio_loin.145b3ba9.m4a";


var $19da66b871701f45$exports = {};

$19da66b871701f45$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Course_mort.543d9aeb.m4a";


var $bf981e0958c155b8$exports = {};

$bf981e0958c155b8$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Course_mort_reverse.d7569a14.m4a";


var $7d62d1abea1a17b8$exports = {};

$7d62d1abea1a17b8$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Attente_cig.2a7016e0.m4a";


var $9fb352858e3cef02$exports = {};

$9fb352858e3cef02$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Attente_vapor.59622743.m4a";


var $4c49955dfd091b81$exports = {};

$4c49955dfd091b81$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Voiture_entree.f030b173.m4a";


var $c30f26c0a63b3183$exports = {};

$c30f26c0a63b3183$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Pas.d3f95d51.m4a";


var $da6e45d5df198b88$exports = {};

$da6e45d5df198b88$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Fin1_gauche_jazz.62b83880.m4a";


var $a91eecf546d0e792$exports = {};

$a91eecf546d0e792$exports = (parcelRequire("aNJCr")).getBundleURL("lmekZ") + "../Fin2_droite_electro.9cda9c9d.m4a";


const $8df1187107336215$var$sounds = [
    {
        name: "ui-pack",
        url: new URL($63cdaed10fce03c5$exports)
    },
    {
        name: "dial-up-modem",
        url: new URL($d78264450f2ab72a$exports)
    },
    {
        name: "foret",
        url: new URL($f9218e9b181772c3$exports)
    },
    {
        name: "branches",
        url: new URL($370d5344dddfcb5d$exports)
    },
    {
        name: "pelle",
        url: new URL($45fc23955f1cdb60$exports)
    },
    {
        name: "riviere",
        url: new URL($7b7df9faf4c17568$exports)
    },
    {
        name: "autoroute",
        url: new URL($2f1d8486ece2ef67$exports)
    },
    {
        name: "voiture-arrive",
        url: new URL($2bf7632f8595d927$exports)
    },
    {
        name: "radio-loin",
        url: new URL($f483ee1086f5baf7$exports)
    },
    {
        name: "course-mort",
        url: new URL($19da66b871701f45$exports)
    },
    {
        name: "course-mort-rev",
        url: new URL($bf981e0958c155b8$exports)
    },
    {
        name: "attente-cigarette",
        url: new URL($7d62d1abea1a17b8$exports)
    },
    {
        name: "attente-vaporette",
        url: new URL($9fb352858e3cef02$exports)
    },
    {
        name: "voiture-entree",
        url: new URL($4c49955dfd091b81$exports)
    },
    {
        name: "pas",
        url: new URL($c30f26c0a63b3183$exports)
    },
    {
        name: "fin-jazz",
        url: new URL($da6e45d5df198b88$exports)
    },
    {
        name: "fin-electro",
        url: new URL($a91eecf546d0e792$exports)
    }
];
function $8df1187107336215$export$2cd8252107eb640b() {
    $8df1187107336215$var$setupMobileKeyboard();
    return $8df1187107336215$var$loadSounds();
}
function $8df1187107336215$var$loadSounds() {
    return Promise.all([
        ...$8df1187107336215$var$sounds.map((sound)=>{
            return $2d353038de4934bf$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}
function $8df1187107336215$var$setupMobileKeyboard() {
    // Trigger mobile keyboard on screen click
    const screenElement = document.querySelector(".screen");
    // Focus input on screen click, raising the keyboard
    screenElement.addEventListener("click", ()=>{
        const input = document.querySelector(".mobile-input");
        input.focus();
    });
    // Prevent hitting enter submitting the mobile form for input
    document.querySelector("form").addEventListener("keypress", (e)=>e.preventDefault());
}


// Development
window.DEVMODE = true;
// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
// calls for line by line time interval in milliseconds)
function $e891fed206f251fc$export$a23ad60f6022999e(name) {
    // TODO: refactor this
    const effects = {
        "validate": {
            initialGain: -12,
            offset: 0.100,
            duration: 0.093
        },
        "error": {
            initialGain: -12,
            offset: 0.200,
            duration: 0.175
        },
        "success": {
            initialGain: -12,
            offset: 0.400,
            duration: 0.148
        },
        "question": {
            initialGain: -12,
            offset: 0.600,
            duration: 0.131
        },
        "notify": {
            initialGain: -12,
            offset: 0.800,
            duration: 0.340
        },
        "connected": {
            initialGain: -18,
            offset: 1.200,
            duration: 0.147
        },
        "disconnected": {
            initialGain: -18,
            offset: 1.400,
            duration: 0.297
        },
        "connecting": {
            initialGain: -18,
            offset: 1.800,
            duration: 5.160
        }
    };
    if (!(name in effects)) return console.error("Error: Uknown soundEffect: " + name);
    $2d353038de4934bf$exports.play("ui-pack", effects[name]);
}
function $e891fed206f251fc$var$init() {
    $f47c83d30a62c4c8$export$2cd8252107eb640b();
    $f47c83d30a62c4c8$export$471f7ae5c4103ae1("Initializing...");
    $236da9fbcdf0e712$export$2cd8252107eb640b();
    $380a3c12bb241012$export$2cd8252107eb640b();
    $f47c83d30a62c4c8$export$471f7ae5c4103ae1("Loading...");
    $8df1187107336215$export$2cd8252107eb640b().then(()=>{
        $f47c83d30a62c4c8$export$4bb981a91e4f02eb();
    });
}
function $e891fed206f251fc$export$b3571188c770cc5a() {
    $346325bb3c7976af$export$889ea624f2cb2c57("10.1.2.3");
}
$e891fed206f251fc$var$init();

})();
//# sourceMappingURL=index.bba47c63.js.map
